module.exports = __webpack_public_path__ + "static/media/s_yellow_1.7959790d.mp3";